import React, { useState } from 'react';
import { CheckCircle2, Loader2, Send } from 'lucide-react';
import { company } from '../mock';
import { useAntiBot, Honeypot } from './useAntiBot';
import TurnstileWidget, { TURNSTILE_ENABLED } from './TurnstileWidget';

const API = process.env.REACT_APP_BACKEND_URL;
const PROJECT_TYPES = [
  'New Construction',
  'Large-Scale Renovation',
  'Commercial Build-Out',
  'Multi-Unit / Phased Project',
  'Other',
];

export default function TradePartnerForm() {
  const [form, setForm] = useState({ companyName: '', name: '', phone: '', email: '', projectType: PROJECT_TYPES[0], message: '' });
  const [state, setState] = useState('idle');
  const { hp, setHp, appendAntiBot } = useAntiBot();
  const [token, setToken] = useState('');
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (TURNSTILE_ENABLED && !token) { setState('error'); return; }
    setState('sending');
    try {
      const details = `Company: ${form.companyName}\nProject type: ${form.projectType}\n\n${form.message || 'Interested in becoming a trade partner.'}`;
      const fd = new FormData();
      fd.append('name', form.name);
      fd.append('phone', form.phone);
      fd.append('email', form.email);
      fd.append('service', 'Trade Partner Inquiry');
      fd.append('message', details);
      appendAntiBot(fd);
      if (token) fd.append('turnstile_token', token);
      const res = await fetch(`${API}/api/contact`, { method: 'POST', body: fd });
      if (!res.ok) throw new Error('bad');
      if (typeof window !== 'undefined') {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'lead_submitted', service: 'Trade Partner Inquiry', page: window.location.pathname });
        if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { service: 'Trade Partner Inquiry' });
      }
      setState('done');
    } catch (err) {
      setState('error');
    }
  };

  if (state === 'done') {
    return (
      <div className="contact-success" data-testid="trade-partner-success">
        <span className="ic-sq"><CheckCircle2 size={26} /></span>
        <h3>Thanks &mdash; we&rsquo;ll be in touch!</h3>
        <p>Your trade partner request is in. We&rsquo;ll reach out to talk through your projects. Need us sooner? Call <a href={company.phoneHref}>{company.phoneDisplay}</a>.</p>
      </div>
    );
  }

  return (
    <form className="contact-form" onSubmit={submit} data-testid="trade-partner-form">
      <Honeypot value={hp} onChange={setHp} />
      <p className="eyebrow">For Builders &amp; General Contractors</p>
      <h3>Become a Trade Partner</h3>
      <p className="lead-form-sub">Tell us about your company and we&rsquo;ll set up your plumbing partnership.</p>
      <label>Company name*<input required value={form.companyName} onChange={set('companyName')} data-testid="tp-company" /></label>
      <div className="cf-row">
        <label>Contact name*<input required value={form.name} onChange={set('name')} data-testid="tp-name" /></label>
        <label>Phone*<input required value={form.phone} onChange={set('phone')} data-testid="tp-phone" /></label>
      </div>
      <label>Email*<input type="email" required value={form.email} onChange={set('email')} data-testid="tp-email" /></label>
      <label>Project type
        <select value={form.projectType} onChange={set('projectType')} data-testid="tp-project-type">
          {PROJECT_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
        </select>
      </label>
      <label>Anything else?
        <textarea rows={3} value={form.message} onChange={set('message')} placeholder="Volume, timelines, typical project size, etc." data-testid="tp-message" />
      </label>
      {state === 'error' && <p className="cf-error" data-testid="tp-error">Please complete the verification below, or call {company.phoneDisplay}.</p>}
      <TurnstileWidget onToken={setToken} />
      <button className="btn btn-gold" type="submit" disabled={state === 'sending'} data-testid="tp-submit">
        {state === 'sending' ? <><Loader2 size={16} className="spin" /> Sending&hellip;</> : <><Send size={16} /> Submit Partnership Request</>}
      </button>
    </form>
  );
}
